<template>
    <div class="bg_eef1fa detail web_detail">
        <div class="main  bg_fff">
                <div class="left_detail" v-html="detail">
                </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "detail",
        data () {
            return {
                id: 0,
                detail:'',
            }
        },

        created() {
            this.id = this.$route.query.id;
            this.$http({
                url: 'index/agree',
                method: 'post',
                headers: {"Content-Type": "multipart/form-data"},
            }).then(res => {
                if(res.data.code == 1) {
                    this.detail = res.data.data;
                } else {
                    layer.msg(res.data.msg);
                }
            });
        },
        mounted() {
        },
        methods: {

        }
    }
</script>

<style scoped>
    .detail{padding:45px 0 35px;min-height: calc(100vh - 410px);}
    .detail .main img{max-width: 100%;margin:0 auto;}
    .left_detail{width: 100%;padding:20px;}
    @media screen and (max-width: 1240px) {
        .web_detail{padding:2% 2% 3.629vw;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/detail.vue